import {Link} from "react-router-dom";
import React from "react";

type Props = {
    to: string;
    label: string;
}

const BackLink = ({to, label}: Props) => {
    return (
        <p>
            <Link to={to}>
                <i className="fa-regular fa-circle-left me-1"></i>
                <span>{label}</span>
            </Link>
        </p>
    );
};

export default BackLink;
